import { api } from "./apiConfig";

export const createCriteria = async (data) => {
  try {
    const token = localStorage.getItem("token");
    const response = await api.post("/Criteria/createCriteria", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const getAllCriteria = async (active = false) => {
  try {
    const response = await api.get(`/Criteria/getAllCriteria/${active}`, {
        headers: {
          'Content-Type': 'application/json',    
          'Accept':'application/json'
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const getCriterion = async (id) => {
  try {
    const token = localStorage.getItem("token");
    const response = await api.get(`/Criteria/getCriterion/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const editCriterion = async (id, data) => {
  try {
    const token = localStorage.getItem("token");
    const response = await api.put(`/Criteria/editCriterion/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const editCriteria = async (data) => {
  try {
    const token = localStorage.getItem("token");
    const response = await api.post("/Criteria/editCriteria", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const deleteCriterion = async (id) => {
  try {
    const token = localStorage.getItem("token");
    const response = await api.delete(`/criteria/deleteCriterion/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("There was an error deleting the criterion!", error);
    throw error;
  }
};

